import useUtils from '@/micro/composables/useUtils'
import { COUNTRY_ALIAS, DEFAULT_COUNTRY, VALID_COUNTRIES } from '@/micro/modules/version'

declare const geoip2: {
  country: (
    success: (response: { country: { iso_code: string }; continent: { code: string } }) => void,
    error: (error: any) => void
  ) => void
}

export default function () {
  const { getUserReferrer } = useUtils()

  const isValidCountry = (country: string) => {
    let finalCountry = country

    if (country in COUNTRY_ALIAS) {
      finalCountry = COUNTRY_ALIAS[country as keyof typeof COUNTRY_ALIAS]
    }

    return VALID_COUNTRIES.includes(finalCountry)
  }

  const getCountryByIP = () => {
    return new Promise<string | undefined>(resolve => {
      try {
        geoip2.country(
          success => {
            resolve(success.country.iso_code)
          },
          error => {
            console.warn(error)
            resolve(undefined)
          }
        )
      } catch (error) {
        console.warn(error)
        resolve(undefined)
      }
    })
  }

  const comesFromLandingCountry = (): string | null => {
    const referrer: string = getUserReferrer()

    const countryPatterns: { code: string; pattern: RegExp }[] = [
      { code: 'CO', pattern: /^(?=.*\balegra\b)(?=.*\bcolombia\b).*$/ },
      { code: 'MX', pattern: /^(?=.*\balegra\b)(?=.*\bmexico\b).*$/ },
      { code: 'AR', pattern: /^(?=.*\balegra\b)(?=.*\bargentina\b).*$/ },
      { code: 'DO', pattern: /^(?=.*\balegra\b)(?=.*\brdominicana\b).*$/ },
      { code: 'CR', pattern: /^(?=.*\balegra\b)(?=.*\bcostarica\b).*$/ },
      { code: 'PE', pattern: /^(?=.*\balegra\b)(?=.*\bperu\b).*$/ },
      { code: 'PA', pattern: /^(?=.*\balegra\b)(?=.*\bpanama\b).*$/ },
      { code: 'ES', pattern: /^www\.alegra\.com\/es(\/.*)?$/ },
      { code: 'VE', pattern: /^(?=.*\balegra\b)(?=.*\bvenezuela\b).*$/ },
    ]

    for (const { code, pattern } of countryPatterns) {
      if (pattern.test(referrer)) {
        return code
      }
    }

    return null
  }

  const getCountryByCode = (
    countryCode: string | null = comesFromLandingCountry()
  ): string | undefined => {
    const countries: Record<string, string> = {
      CO: 'colombia',
      MX: 'mexico',
      AR: 'argentina',
      DO: 'republicaDominicana',
      CR: 'costaRica',
      PE: 'peru',
      PA: 'panama',
      ES: 'spain',
      VE: 'venezuela',
    }

    return countryCode ? countries[countryCode] : undefined
  }

  const getApplicationVersion = async (): Promise<string | null> => {
    // Analizar la URL directamente
    const path = window.location.pathname
    const countryMatch = path.match(/\/country\/([^\/]+)/)
    const countryParam = countryMatch ? countryMatch[1] : undefined

    if (countryParam && isValidCountry(countryParam)) {
      return COUNTRY_ALIAS[countryParam as keyof typeof COUNTRY_ALIAS] || countryParam
    }

    const countryByCode = getCountryByCode()
    if (countryByCode) {
      return countryByCode
    }

    const countryIsoCode = await getCountryByIP()
    const countryFromIso = getCountryByCode(countryIsoCode)
    if (countryFromIso) {
      return countryFromIso
    }

    return DEFAULT_COUNTRY
  }

  return {
    getCountryByIP,
    comesFromLandingCountry,
    getCountryByCode,
    getApplicationVersion,
  }
}
